import React from 'react';
import { fleetTripHistoryRoute } from '@/modules/administration/fleet-trip-history/routes';
import { createRoute } from '@tanstack/react-router';

export const fleetTripHistoryIndexRoute = createRoute({
  getParentRoute: () => fleetTripHistoryRoute,
  path: '/',
  wrapInSuspense: true,
  component: React.lazy(async () => await import('@/app/routes/Admin/FleetTripHistory')),
});
